import { StartDateConfiguration } from "@/apollo/types";
import DateInput, { DateInputPreset } from "@/components/elements/DateInput";
import { dayjs, toLocalCalendarDay, toUtcCalendarDay } from "@/utils/date";

function getPresets(): DateInputPreset[] {
  const now = dayjs();
  return [
    {
      label: "Today",
      date: now.startOf("day").toDate(),
      group: "relative",
    },
    {
      label: "30 days ago",
      date: now.subtract(30, "day").startOf("day").toDate(),
      group: "relative",
    },
    {
      label: "90 days ago",
      date: now.subtract(90, "day").startOf("day").toDate(),
      group: "relative",
    },
    {
      label: "This year",
      date: now.startOf("year").toDate(),
      group: "period",
    },
    ...[1, 2, 3].map((yearsAgo) => {
      const year = now.subtract(yearsAgo, "year").startOf("year");
      return {
        label: year.format("YYYY"),
        date: year.toDate(),
        group: "years",
      };
    }),
  ];
}

export default function StartDateConfig(props: {
  /** The stored day, as `onChange` last emitted it. */
  value?: string | null;
  startDateConfig?: StartDateConfiguration | null;
  /** The picked day at UTC midnight, ISO formatted, or null when cleared. */
  onChange: (date: string | null) => void;
}) {
  const presets = getPresets();
  const minDate = props.startDateConfig?.maxLookbackDays
    ? dayjs().subtract(props.startDateConfig.maxLookbackDays, "day").toDate()
    : undefined;

  return (
    <div className="space-y-4">
      <div className="text-sm">Limit historical data</div>

      <div>
        <p className="mb-2 text-xs text-muted-foreground">
          Only sync data after the selected date
        </p>
        <DateInput
          minDate={minDate}
          date={props.value ? toLocalCalendarDay(new Date(props.value)) : null}
          setDate={(date) =>
            props.onChange(date ? toUtcCalendarDay(date).toISOString() : null)
          }
          placeholder="Select date..."
          presets={presets}
        />
        {props.startDateConfig?.maxLookbackDaysDescription && (
          <p className="mt-2 text-xs text-gray-500 dark:text-gray-400">
            {props.startDateConfig.maxLookbackDaysDescription}
          </p>
        )}
      </div>
    </div>
  );
}
